const RequestStatus = {
  CREATED: "CREATED",
  ASSIGNED: "ASSIGNED",
  INPROGRESS: "INPROGRESS",
  COMPLETED: "COMPLETED",
};

export default RequestStatus;
